import { gql } from '@apollo/client';

export default gql`
  query templates($page: Int, $name: String, $templateId: ID!) {
    templates(page: $page, name: $name) {
      templatesTotalPages
      templatesTotal
      perPage
      hasNextPage
      templates {
        id
        name
      }
    }
    template(id: $templateId) {
      id
      name
      periodCycle
      periodNumber
      templateFields {
        id
        name
        order
      }
    }
  }
`;
